<div id="c_related_plannedoutages_heading">
    {{'RelatedPlannedOutages.relatedPlannedOutagesHeader' | translate}}
</div>

<div id="c_related_planned_outages" *ngFor="let relatedPlannedOutage of relatedPlannedOutages ">
    <div class="c-related-planned-outages-reason-icon"></div>
    <div ellipsis class="c-related-planned-outages-reason" (click)="onClickReason(relatedPlannedOutage.plannedOutageId)" >
       {{relatedPlannedOutage.reason}}
   </div>
            <ul id="c-related-planned-outages-attr-list">
                <li>
                    <span class="c-related-planned-outages-date">{{'RelatedPlannedOutages.startDate' | translate}}</span>:
                    <span>{{relatedPlannedOutage.startDate}}</span>
                </li>
                <li>
                    <span class="c-related-planned-outages-date">{{'RelatedPlannedOutages.endDate' | translate}}</span>:
                    <span>{{relatedPlannedOutage.endDate}}</span>
                </li>
            </ul>
      
</div>
<div *ngIf="relatedPlannedOutagesCount <= 0" class="text-center">
    {{ 'DataTableList.noRecords' | translate }} 
</div>


